export const ListQueryKey = 'couponRecords';
export const DetailQueryKey = 'couponRecord';

export const Urls = {
  selectUrl: '/couponRecord/list',
  updateUrl: '/couponRecord/update',
  deleteUrl: '/couponRecord/delete',
  createUrl: '/couponRecord/create',
  detailUrl: '/couponRecord/info',
};
